<template>
  <footer v-if="variants.v1 === variant" class="footer tw-bg-[var(--c-primary)] tw-py-10 tw-text-white">
    <div class="container tw-mx-auto tw-px-4">
      <div class="tw-mb-12 tw-grid tw-grid-cols-1 tw-gap-8 lg:tw-grid-cols-12">
        <!-- LOGO ve İletişim Bloğu -->
        <div class="tw-order-1 tw-flex tw-flex-col tw-items-center lg:tw-order-2 lg:tw-col-span-8">
          <!-- Logo -->
          <NuxtImg :src="logo" alt="Cope&Co. Estate Agents" class="tw-mb-8 tw-w-56" />
          <!-- Telefon -->
          <h2 class="tw-mb-8 tw-text-2xl tw-font-medium tw-text-[var(--c-secondary)]">
            {{ vars.companyPhoneText }}
          </h2>
          <div class="tw-mb-8 tw-flex tw-gap-3">
            <nuxt-link
              v-if="vars.facebookUrl"
              :external="true"
              :to="vars.facebookUrl"
              aria-label="Facebook"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.33317 9.00016H10.9998L11.6665 6.3335H9.33317V5.00016C9.33317 4.3135 9.33317 3.66683 10.6665 3.66683H11.6665V1.42683C11.4492 1.39816 10.6285 1.3335 9.76184 1.3335C7.95184 1.3335 6.6665 2.43816 6.6665 4.46683V6.3335H4.6665V9.00016H6.6665V14.6668H9.33317V9.00016Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.linkedinUrl"
              :external="true"
              :to="vars.linkedinUrl"
              aria-label="LinkedIn"
              target="_blank"
              class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.62663 3.33351C4.62645 3.68713 4.48581 4.0262 4.23563 4.27613C3.98546 4.52605 3.64625 4.66636 3.29263 4.66618C2.93901 4.666 2.59994 4.52536 2.35001 4.27518C2.10009 4.02501 1.95978 3.6858 1.95996 3.33218C1.96014 2.97856 2.10078 2.63949 2.35096 2.38956C2.60113 2.13964 2.94034 1.99934 3.29396 1.99951C3.64758 1.99969 3.98665 2.14033 4.23658 2.39051C4.4865 2.64068 4.6268 2.97989 4.62663 3.33351ZM4.66663 5.65351H1.99996V14.0002H4.66663V5.65351ZM8.87996 5.65351H6.22663V14.0002H8.85329V9.62018C8.85329 7.18018 12.0333 6.95351 12.0333 9.62018V14.0002H14.6666V8.71351C14.6666 4.60018 9.95996 4.75351 8.85329 6.77351L8.87996 5.65351Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.instagramUrl"
              :external="true"
              :to="vars.instagramUrl"
              aria-label="Instagram"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.20016 1.3335H10.8002C12.9335 1.3335 14.6668 3.06683 14.6668 5.20016V10.8002C14.6668 11.8257 14.2594 12.8092 13.5343 13.5343C12.8092 14.2594 11.8257 14.6668 10.8002 14.6668H5.20016C3.06683 14.6668 1.3335 12.9335 1.3335 10.8002V5.20016C1.3335 4.17466 1.74088 3.19116 2.46602 2.46602C3.19116 1.74088 4.17466 1.3335 5.20016 1.3335ZM5.06683 2.66683C4.43031 2.66683 3.81986 2.91969 3.36977 3.36977C2.91969 3.81986 2.66683 4.43031 2.66683 5.06683V10.9335C2.66683 12.2602 3.74016 13.3335 5.06683 13.3335H10.9335C11.57 13.3335 12.1805 13.0806 12.6306 12.6306C13.0806 12.1805 13.3335 11.57 13.3335 10.9335V5.06683C13.3335 3.74016 12.2602 2.66683 10.9335 2.66683H5.06683ZM11.5002 3.66683C11.7212 3.66683 11.9331 3.75463 12.0894 3.91091C12.2457 4.06719 12.3335 4.27915 12.3335 4.50016C12.3335 4.72118 12.2457 4.93314 12.0894 5.08942C11.9331 5.2457 11.7212 5.3335 11.5002 5.3335C11.2791 5.3335 11.0672 5.2457 10.9109 5.08942C10.7546 4.93314 10.6668 4.72118 10.6668 4.50016C10.6668 4.27915 10.7546 4.06719 10.9109 3.91091C11.0672 3.75463 11.2791 3.66683 11.5002 3.66683ZM8.00016 4.66683C8.88422 4.66683 9.73206 5.01802 10.3572 5.64314C10.9823 6.26826 11.3335 7.11611 11.3335 8.00016C11.3335 8.88422 10.9823 9.73206 10.3572 10.3572C9.73206 10.9823 8.88422 11.3335 8.00016 11.3335C7.11611 11.3335 6.26826 10.9823 5.64314 10.3572C5.01802 9.73206 4.66683 8.88422 4.66683 8.00016C4.66683 7.11611 5.01802 6.26826 5.64314 5.64314C6.26826 5.01802 7.11611 4.66683 8.00016 4.66683ZM8.00016 6.00016C7.46973 6.00016 6.96102 6.21088 6.58595 6.58595C6.21088 6.96102 6.00016 7.46973 6.00016 8.00016C6.00016 8.5306 6.21088 9.0393 6.58595 9.41438C6.96102 9.78945 7.46973 10.0002 8.00016 10.0002C8.5306 10.0002 9.0393 9.78945 9.41438 9.41438C9.78945 9.0393 10.0002 8.5306 10.0002 8.00016C10.0002 7.46973 9.78945 6.96102 9.41438 6.58595C9.0393 6.21088 8.5306 6.00016 8.00016 6.00016Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.youtubeUrl"
              :external="true"
              :to="vars.youtubeUrl"
              aria-label="YouTube"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_23_2087)">
                  <path
                    d="M8.00016 2.6665C8.57016 2.6665 9.15483 2.68117 9.7215 2.70517L10.3908 2.73717L11.0315 2.77517L11.6315 2.81584L12.1795 2.8585C12.7742 2.90402 13.3338 3.1578 13.7598 3.5752C14.1859 3.99259 14.4511 4.54686 14.5088 5.1405L14.5355 5.42384L14.5855 6.0305C14.6322 6.65917 14.6668 7.3445 14.6668 7.99984C14.6668 8.65517 14.6322 9.3405 14.5855 9.96917L14.5355 10.5758C14.5268 10.6732 14.5182 10.7672 14.5088 10.8592C14.4511 11.4529 14.1858 12.0073 13.7596 12.4247C13.3334 12.8421 12.7736 13.0958 12.1788 13.1412L11.6322 13.1832L11.0322 13.2245L10.3908 13.2625L9.7215 13.2945C9.14805 13.3194 8.57415 13.3323 8.00016 13.3332C7.42618 13.3323 6.85227 13.3194 6.27883 13.2945L5.6095 13.2625L4.96883 13.2245L4.36883 13.1832L3.82083 13.1412C3.22613 13.0957 2.66653 12.8419 2.24048 12.4245C1.81443 12.0071 1.54921 11.4528 1.4915 10.8592L1.46483 10.5758L1.41483 9.96917C1.36385 9.31393 1.33673 8.65705 1.3335 7.99984C1.3335 7.3445 1.36816 6.65917 1.41483 6.0305L1.46483 5.42384C1.4735 5.3265 1.48216 5.2325 1.4915 5.1405C1.54919 4.54697 1.81431 3.99278 2.24022 3.5754C2.66614 3.15802 3.22558 2.90417 3.82016 2.8585L4.3675 2.81584L4.9675 2.77517L5.60883 2.73717L6.27816 2.70517C6.85183 2.68026 7.42596 2.66737 8.00016 2.6665ZM8.00016 3.99984C7.45016 3.99984 6.88416 4.0145 6.3335 4.03717L5.6815 4.0685L5.0555 4.10517L4.4675 4.14517L3.92883 4.18717C3.64572 4.20726 3.37886 4.32693 3.17556 4.52499C2.97226 4.72304 2.84564 4.98668 2.81816 5.26917C2.74016 6.07517 2.66683 7.0785 2.66683 7.99984C2.66683 8.92117 2.74016 9.9245 2.81816 10.7305C2.87483 11.3118 3.33616 11.7638 3.92883 11.8125L4.4675 11.8538L5.0555 11.8938L5.6815 11.9312L6.3335 11.9625C6.88416 11.9852 7.45016 11.9998 8.00016 11.9998C8.55016 11.9998 9.11616 11.9852 9.66683 11.9625L10.3188 11.9312L10.9448 11.8945L11.5328 11.8545L12.0715 11.8125C12.3546 11.7924 12.6215 11.6727 12.8248 11.4747C13.0281 11.2766 13.1547 11.013 13.1822 10.7305C13.2602 9.9245 13.3335 8.92117 13.3335 7.99984C13.3335 7.0785 13.2602 6.07517 13.1822 5.26917C13.1547 4.98668 13.0281 4.72304 12.8248 4.52499C12.6215 4.32693 12.3546 4.20726 12.0715 4.18717L11.5328 4.14584L10.9448 4.10584L10.3188 4.0685L9.66683 4.03717C9.11159 4.01328 8.55592 4.00083 8.00016 3.99984ZM6.66683 6.38317C6.66679 6.31801 6.68266 6.25383 6.71307 6.19621C6.74349 6.13858 6.78751 6.08926 6.84133 6.05253C6.89515 6.01579 6.95712 5.99277 7.02187 5.98544C7.08661 5.97812 7.15217 5.98672 7.21283 6.0105L7.26683 6.03717L10.0668 7.65317C10.1226 7.68534 10.1698 7.73049 10.2043 7.78479C10.2389 7.83909 10.2599 7.90094 10.2654 7.96507C10.271 8.0292 10.261 8.09373 10.2363 8.15317C10.2116 8.21261 10.1729 8.26521 10.1235 8.3065L10.0668 8.3465L7.26683 9.96317C7.2104 9.99584 7.14685 10.0142 7.08169 10.0167C7.01654 10.0192 6.95176 10.0058 6.893 9.97749C6.83424 9.94923 6.78328 9.90703 6.74456 9.85457C6.70584 9.80211 6.68053 9.74098 6.67083 9.6765L6.66683 9.6165V6.38317Z"
                    fill="var(--c-primary)"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_23_2087">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.tiktokUrl"
              :external="true"
              :to="vars.tiktokUrl"
              aria-label="TikTok"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.0668 3.88C10.6111 3.35975 10.3599 2.69162 10.3601 2H8.3001V10.2667C8.28422 10.714 8.09535 11.1377 7.77328 11.4486C7.45121 11.7595 7.02107 11.9333 6.57344 11.9333C5.62677 11.9333 4.8401 11.16 4.8401 10.2C4.8401 9.05333 5.94677 8.19333 7.08677 8.54667V6.44C4.78677 6.13333 2.77344 7.92 2.77344 10.2C2.77344 12.42 4.61344 14 6.56677 14C8.6601 14 10.3601 12.3 10.3601 10.2V6.00667C11.1954 6.60657 12.1983 6.92843 13.2268 6.92667V4.86667C13.2268 4.86667 11.9734 4.92667 11.0668 3.88Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
          </div>

          <!-- Mail -->
          <p class="tw-mb-6">
            <a
              href="mailto:contact@copeandco.co.uk"
              class="tw-text-white hover:tw-cursor-pointer hover:tw-text-[var(--c-secondary)]"
            >
              contact@copeandco.co.uk
            </a>
          </p>

          <!-- Contact Us -->
          <p v-for="(middle, index) in middles" :key="index" class="tw-mb-6 last:tw-mb-10">
            <nuxt-link :to="middle.link" :external="true" class="tw-text-white hover:tw-text-[var(--c-secondary)]">
              {{ middle.title }}
            </nuxt-link>
          </p>

          <!-- Örnek bloklar -->
          <div class="tw-mb-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
            <div v-for="(card, index) in cards" :key="index" class="tw-h-12 tw-w-32 tw-overflow-hidden tw-bg-gray-200">
              <img :src="card.photo" class="tw-h-full tw-w-full tw-object-cover" />
            </div>
          </div>
        </div>

        <!-- Menü Bloğu -->

        <div v-if="columns1" class="tw-order-2 lg:tw-order-1 lg:tw-col-span-2">
          <h4 class="mb-4">{{ vars.columnTitle1Text }}</h4>
          <div class="footer__list tw-flex tw-flex-col tw-space-y-6">
            <nuxt-link
              v-for="(item, index) in columns1"
              :to="item.link"
              :external="true"
              :key="index"
              class="n-link tw-block hover:tw-text-[var(--c-secondary)]"
            >
              <h4>{{ item.item }}</h4>
            </nuxt-link>
          </div>
        </div>

        <!-- Bilgilendirme/Künye Bloğu -->
        <div class="info tw-order-3 tw-space-y-2 lg:tw-order-3 lg:tw-col-span-2">
          <p>{{ vars.companyTradingAsText }}, Trading As:</p>
          <p>{{ vars.descriptionText }}</p>
          <p>Company Number: {{ vars.companyNumberText }}</p>
          <p>Registered Address: {{ vars.companyAddressText }}</p>
          <p>
            Redress Scheme:
            {{ vars.companyRedressSchemeText }}
          </p>
          <p>
            <a :href="vars.companyRedressSchemeLinkUrl" 
              class="n-link tw-break-words"
              :aria-label="`Visit ${vars.companyRedressSchemeText} website`"
              target="_blank" 
              rel="noreferrer">
              {{ vars.companyRedressSchemeLinkUrl }}
            </a>
          </p>

          <div>
            <div
              class="tw-pt-6"
              v-for="(logo, index) in redress"
              :key="`redressLogos-${index}`"
              data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e547"
            >
              <img style="max-height: 42px" :title="logo.title" alt="redress logo" :src="logo.photo" />
          </div>
          </div>
        </div>
      </div>

      <!-- En aşağıdaki içerikler -->
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-y-3 tw-pt-4 tw-text-xs md:tw-flex-row md:tw-gap-x-4 lg:tw-gap-x-0"
      >
        <span class="tw-text-center">
          © {{ new Date().getFullYear() }} Cope&Co. Estate Agents. All rights reserved.
        </span>
        <span class="tw-text-center lg:tw-mr-[220px]">
          Powered by
          <a href="https://www.iceberg-digital.co.uk/neuron/home" target="_blank" class="n-link"> <b>Neuron</b></a>
          |
          <a href="https://www.iceberg-digital.co.uk/" target="_blank" class="n-link"><b>Iceberg Digital</b></a>
        </span>
        <span>
          <nuxt-link
            :to="vars.privacyLinkUrl || '/privacy-policy'"
            :external="true"
            :target="vars.privacyLinkUrl && vars.privacyLinkUrl.startsWith('http') ? '_blank' : undefined"
            class="n-link tw-text-[var(--c-text-tertiary)] hover:tw-text-[var(--c-secondary)]"
          >
            Privacy Policy
          </nuxt-link>
        </span>
      </div>
    </div>
  </footer>

  <footer
    v-else-if="variants.v2 === variant"
    class="footer -type-2"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-text_primary)`"
  >
    <div class="container tw-border-t tw-pt-10">
      <div class="row y-gap-30 justify-between">
        <div class="col-auto">
          <div class="footer__logo">
            <!-- light/dark logo switch -->
            <img :src="logoV2" alt="logo icon" />
          </div>
        </div>

        <div class="col-xl-6 col-lg-7">
          <div class="tw-flex tw-items-center tw-justify-start tw-gap-3 lg:tw-justify-end">
            <nuxt-link
              v-if="vars.facebookUrl"
              :external="true"
              :to="vars.facebookUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                  <path
                    d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                    fill="#2b2b2b"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.tiktokUrl"
              :external="true"
              :to="vars.tiktokUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                  <path
                    d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                    fill="#2b2b2b"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.instagramUrl"
              :external="true"
              :to="vars.instagramUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                  <path
                    d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                    fill="#2b2b2b"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.youtubeUrl"
              :external="true"
              :to="vars.youtubeUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                  <path
                    d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                    fill="#2b2b2b"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.linkedinUrl"
              :external="true"
              :to="vars.linkedinUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" fill="#EF787C" class="tw-duration-300 group-hover:tw-fill-white" />
                  <path
                    d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                    fill="#2b2b2b"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>
      </div>

      <div class="row y-gap-30 justify-between tw-mt-5">
        <div v-if="columns1" class="col-lg-4 lg:tw-hidden">
          <h5>{{ vars.columnTitle1Text }}</h5>
          <div class="footer__list">
            <nuxt-link v-for="(item, index) in columns1" :to="item.link" :external="true" :key="index" class="n-link"
              ><p>{{ item.item }}</p></nuxt-link
            >
          </div>
        </div>

        <div class="col-lg-4 tw-hidden tw-flex-col lg:tw-flex">
          <p>{{ vars.companyTradingAsText }}</p>
          <p>{{ vars.companyText }}</p>
          <p class="tw-whitespace-nowrap">Company Number: {{ vars.companyNumberText }}</p>
          <p>Registered Address: {{ vars.companyAddressText }}</p>
          <p>
            Redress Scheme:
            {{ vars.redressSchemeText }}
          </p>
          <p>
            <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
              {{ vars.companyRedressSchemeLinkUrl }}
            </a>
          </p>
          <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
            <img style="max-height: 52px; min-width: 56px" :title="logo.title" :alt="logo.title" :src="logo.photo" />
          </a>
        </div>

        <div class="col-xl-6 col-lg-7 tw-mt-5">
          <div class="justify-between tw-flex tw-flex-col tw-gap-y-12 lg:tw-flex-row">
            <div v-if="columns1" class="col-lg-4 tw-hidden tw-flex-col lg:tw-flex">
              <h5>{{ vars.columnTitle1Text }}</h5>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns1"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><p>{{ item.item }}</p></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns2" class="col-md-auto col-6">
              <h5>{{ vars.columnTitle2Text }}</h5>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns2"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><p>{{ item.item }}</p></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns3" class="col-md-auto col-6">
              <h5>{{ vars.columnTitle3Text }}</h5>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns3"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><p>{{ item.item }}</p></nuxt-link
                >
              </div>
            </div>

            <div class="col-md-auto col-6">
              <div class="footer__list !tw-mt-0 lg:tw-hidden">
                <p>{{ vars.companyTradingAsText }}</p>
                <p>{{ vars.companyText }}</p>
                <p class="tw-whitespace-nowrap">Company Number: {{ vars.phoneNumber }}</p>
                <p>Registered Address: {{ vars.companyAddressText }}</p>
                <p>
                  Redress Scheme:
                  {{ vars.redressSchemeText }}
                </p>
                <p>
                  <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
                    {{ vars.companyRedressSchemeLinkUrl }}
                  </a>
                </p>
                <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
                  <img
                    style="max-height: 52px; min-width: 56px"
                    :title="logo.title"
                    :alt="logo.title"
                    :src="logo.photo"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer__bottom tw-mt-6">
        <div class="row justify-between md:justify-center">
          <div class="col-auto lg:tw-w-full">
            <div class="row X-gap-10 y-gap-10 tw-items-center lg:tw-flex-row-reverse lg:tw-justify-between">
              <div class="col-auto"><library-footer-iceberg-links /></div>
              <div class="col-auto" style="font-size: 14px !important">
                © {{ new Date().getFullYear() }} {{ company.name }}. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <footer
    v-else-if="variants.v3 === variant"
    class="footer -type-2"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-text_primary)`"
  >
    <div class="container tw-border-t tw-pt-10">
      <div class="row y-gap-30 justify-between tw-items-start">
        <!-- Logo Column - Desktop'ta sol tarafta -->
        <div class="col-lg-4 tw-flex tw-flex-col tw-justify-start">
          <div class="footer__logo tw-mb-6">
            <img :src="logo" alt="logo icon" />
          </div>

          <!-- Company Info - Desktop'ta logo altında -->
          <div class="tw-hidden tw-flex-col lg:tw-flex">
            <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyTradingAsText }}</p>
            <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyText }}</p>
            <p class="tw-whitespace-nowrap" :style="`color: var(--c-${vars.textColor})`">
              Company Number: {{ vars.companyNumberText }}
            </p>
            <p :style="`color: var(--c-${vars.textColor})`">Registered Address: {{ vars.companyAddressText }}</p>
            <p :style="`color: var(--c-${vars.textColor})`">
              Redress Scheme:
              {{ vars.companyRedressSchemeText }}
            </p>
            <p :style="`color: var(--c-${vars.textColor})`">
              <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
                {{ vars.companyRedressSchemeLinkUrl }}
              </a>
            </p>
            <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
              <img style="max-height: 52px; min-width: 56px" :title="logo.title" :alt="logo.title" :src="logo.photo" />
            </a>
          </div>

          <!-- Mobile Social Media -->
          <div class="tw-mt-4 tw-flex tw-items-center tw-justify-start tw-gap-3 lg:tw-hidden">
            <nuxt-link
              v-if="vars.facebookUrl"
              :external="true"
              :to="vars.facebookUrl"
              target="_blank"
              class="n-link tw-group"
              aria-label="Facebook"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.tiktokUrl"
              :external="true"
              :to="vars.tiktokUrl"
              target="_blank"
              class="n-link tw-group"
              aria-label="TikTok"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.instagramUrl"
              :external="true"
              :to="vars.instagramUrl"
              target="_blank"
              class="n-link tw-group"
              aria-label="Instagram"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.youtubeUrl"
              :external="true"
              :to="vars.youtubeUrl"
              target="_blank"
              class="n-link tw-group"
              aria-label="YouTube"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.linkedinUrl"
              :external="true"
              :to="vars.linkedinUrl"
              target="_blank"
              class="n-link tw-group"
              aria-label="LinkedIn"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>

        <!-- Mobile Only - Column 1 -->
        <div v-if="columns1" class="col-lg-4 lg:tw-hidden">
          <h5 :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle1Text }}</h5>
          <div class="footer__list">
            <nuxt-link v-for="(item, index) in columns1" :to="item.link" :external="true" :key="index" class="n-link"
              ><p :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</p></nuxt-link
            >
          </div>
        </div>

        <!-- Right Side Columns Container -->
        <div class="col-xl-6 col-lg-7">
          <div class="justify-between tw-flex tw-flex-col tw-gap-y-12 lg:tw-flex-row">
            <div v-if="columns1" class="col-lg-4 tw-hidden tw-flex-col lg:tw-flex">
              <h5 :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle1Text }}</h5>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns1"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><p :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</p></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns2" class="col-md-auto col-6">
              <h5 :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle2Text }}</h5>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns2"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><p :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</p></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns3" class="col-md-auto col-6">
              <h5 :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle3Text }}</h5>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns3"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><p :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</p></nuxt-link
                >
              </div>
            </div>

            <!-- Mobile Company Info Section -->
            <div class="col-md-auto col-6 lg:tw-hidden">
              <div class="footer__list !tw-mt-0">
                <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyTradingAsText }}</p>
                <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyText }}</p>
                <p class="tw-whitespace-nowrap" :style="`color: var(--c-${vars.textColor})`">
                  Company Number: {{ vars.phoneNumber }}
                </p>
                <p :style="`color: var(--c-${vars.textColor})`">Registered Address: {{ vars.companyAddressText }}</p>
                <p :style="`color: var(--c-${vars.textColor})`">
                  Redress Scheme:
                  {{ vars.companyRedressSchemeText }}
                </p>
                <p :style="`color: var(--c-${vars.textColor})`">
                  <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
                    {{ vars.companyRedressSchemeLinkUrl }}
                  </a>
                </p>
                <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
                  <img
                    style="max-height: 52px; min-width: 56px"
                    :title="logo.title"
                    :alt="logo.title"
                    :src="logo.photo"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="row y-gap-30 justify-between tw-mt-5 tw-hidden lg:tw-block">
            <h5 :style="`color: var(--c-${vars.titleColor})`">CHECK OUT THE LATEST UPDATES ON:</h5>
            <div class="tw-flex tw-items-center tw-justify-start tw-gap-3">
              <nuxt-link
                v-if="vars.facebookUrl"
                :external="true"
                :to="vars.facebookUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.tiktokUrl"
                :external="true"
                :to="vars.tiktokUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.instagramUrl"
                :external="true"
                :to="vars.instagramUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.youtubeUrl"
                :external="true"
                :to="vars.youtubeUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.linkedinUrl"
                :external="true"
                :to="vars.linkedinUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer__bottom tw-mt-16 tw-py-4"
      :style="`background-color: var(--c-${vars.footerBackgroundColor}); padding-top: 30px !important; padding-bottom: 30px !important; `"
    >
      <div class="container">
        <div class="row justify-between md:justify-center">
          <div class="col-auto lg:tw-w-full">
            <div class="row X-gap-10 y-gap-10 tw-items-center lg:tw-flex-row-reverse lg:tw-justify-between">
              <div class="col-auto"><library-footer-iceberg-links /></div>
              <div class="col-auto" style="font-size: 14px !important">
                © {{ new Date().getFullYear() }} {{ company.name }}. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <!-- Variant 4 (kinetic) -->

  <footer
    v-else-if="variants.v4 === variant"
    :class="['footer -type-2', { 'no-margin-top': company.company_key === 'kineticestateagents' }]"
    class="!tw-pt-10 lg:!tw-pt-16"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-text_primary)`"
  >
    <div class="container tw-pt-10">
      <div class="row y-gap-30 justify-between tw-items-start">
        <!-- Logo Column - Desktop'ta sol tarafta -->
        <div class="col-lg-4 tw-flex tw-flex-col tw-justify-start">
          <div class="footer__logo tw-mb-6">
            <img :src="logo" alt="logo icon" />
          </div>

          <!-- Company Info - Desktop'ta logo altında -->
          <div class="tw-hidden tw-flex-col lg:tw-flex">
            <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyTradingAsText }}</p>
            <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyText }}</p>
            <p class="tw-whitespace-nowrap" :style="`color: var(--c-${vars.textColor})`">
              Company Number: {{ vars.companyNumberText }}
            </p>
            <p :style="`color: var(--c-${vars.textColor})`">Registered Address: {{ vars.companyAddressText }}</p>
            <p :style="`color: var(--c-${vars.textColor})`">
              Redress Scheme:
              {{ vars.redressSchemeText }}
            </p>
            <p :style="`color: var(--c-${vars.textColor})`">
              <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
                {{ vars.companyRedressSchemeLinkUrl }}
              </a>
            </p>
            <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
              <img style="max-height: 52px; min-width: 56px" :title="logo.title" :alt="logo.title" :src="logo.photo" />
            </a>
          </div>

          <!-- Mobile Social Media -->
          <div class="tw-mt-4 tw-flex tw-items-center tw-justify-start tw-gap-3 lg:tw-hidden">
            <nuxt-link
              v-if="vars.facebookUrl"
              :external="true"
              :to="vars.facebookUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.tiktokUrl"
              :external="true"
              :to="vars.tiktokUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.instagramUrl"
              :external="true"
              :to="vars.instagramUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.youtubeUrl"
              :external="true"
              :to="vars.youtubeUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.linkedinUrl"
              :external="true"
              :to="vars.linkedinUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="#fff"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                  />
                  <path
                    d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>

        <!-- Mobile Only - Column 1 -->
        <div v-if="columns1" class="col-lg-4 lg:tw-hidden">
          <h4 class="mb-4" :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle1Text }}</h4>
          <div class="footer__list">
            <nuxt-link v-for="(item, index) in columns1" :to="item.link" :external="true" :key="index" class="n-link"
              ><h6 class="mt-3" :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</h6></nuxt-link
            >
          </div>
        </div>

        <!-- Right Side Columns Container -->
        <div class="col-xl-6 col-lg-7">
          <div class="justify-between tw-flex tw-flex-col tw-gap-y-12 lg:tw-flex-row">
            <div v-if="columns1" class="col-lg-4 tw-hidden tw-flex-col lg:tw-flex">
              <h4 :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle1Text }}</h4>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns1"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link mt-4"
                  ><h6 :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</h6></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns2" class="col-md-auto col-6">
              <h4 :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle2Text }}</h4>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns2"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link mt-4"
                  ><h6 :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</h6></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns3" class="col-md-auto col-6">
              <h4 :style="`color: var(--c-${vars.titleColor})`">{{ vars.columnTitle3Text }}</h4>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns3"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link mt-4"
                  ><h6 :style="`color: var(--c-${vars.textColor})`">{{ item.item }}</h6></nuxt-link
                >
              </div>
            </div>

            <!-- Mobile Company Info Section -->
            <div class="col-md-auto col-6 lg:tw-hidden">
              <div class="footer__list !tw-mt-0">
                <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyTradingAsText }}</p>
                <p :style="`color: var(--c-${vars.textColor})`">{{ vars.companyText }}</p>
                <p class="tw-whitespace-nowrap" :style="`color: var(--c-${vars.textColor})`">
                  Company Number: {{ vars.phoneNumber }}
                </p>
                <p :style="`color: var(--c-${vars.textColor})`">Registered Address: {{ vars.companyAddressText }}</p>
                <p :style="`color: var(--c-${vars.textColor})`">
                  Redress Scheme:
                  {{ vars.redressSchemeText }}
                </p>
                <p :style="`color: var(--c-${vars.textColor})`">
                  <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
                    {{ vars.companyRedressSchemeLinkUrl }}
                  </a>
                </p>
                <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
                  <img
                    style="max-height: 52px; min-width: 56px"
                    :title="logo.title"
                    :alt="logo.title"
                    :src="logo.photo"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="row y-gap-30 justify-between tw-mt-12 tw-hidden lg:tw-block">
            <h4 :style="`color: var(--c-${vars.titleColor})`">CHECK OUT THE LATEST UPDATES ON:</h4>
            <div class="tw-flex tw-items-center tw-justify-start tw-gap-3">
              <nuxt-link
                v-if="vars.facebookUrl"
                :external="true"
                :to="vars.facebookUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.tiktokUrl"
                :external="true"
                :to="vars.tiktokUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.instagramUrl"
                :external="true"
                :to="vars.instagramUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.youtubeUrl"
                :external="true"
                :to="vars.youtubeUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>

              <nuxt-link
                v-if="vars.linkedinUrl"
                :external="true"
                :to="vars.linkedinUrl"
                target="_blank"
                class="n-link tw-group"
              >
                <span>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="18"
                      fill="#FFFFFF"
                      class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
                    />
                    <path
                      d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer__bottom tw-mt-16 tw-py-4"
      :style="`background-color: var(--c-${vars.footerBackgroundColor}); padding-top: 30px !important; padding-bottom: 30px !important; `"
    >
      <div class="container">
        <div class="row justify-between md:justify-center">
          <div class="col-auto lg:tw-w-full">
            <div class="row X-gap-10 y-gap-10 tw-items-center lg:tw-flex-row-reverse lg:tw-justify-between">
              <div class="col-auto"><library-footer-iceberg-links /></div>
              <div class="col-auto" style="font-size: 14px !important">
                © {{ new Date().getFullYear() }} {{ company.name }}. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <footer
    v-else-if="variants.v5 === variant"
    class="footer -type-2 !tw-pt-0"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-text_primary)`"
  >
    <div class="container tw-border-t tw-pt-10" style="border-color: #575757">
      <div class="row y-gap-30 justify-between">
        <div class="col-auto">
          <div class="footer__logo">
            <!-- light/dark logo switch -->
            <img :src="logoV2" alt="logo icon" />
          </div>
        </div>

        <div class="col-xl-6 col-lg-7">
          <div class="tw-flex tw-items-center tw-justify-start tw-gap-3 lg:tw-justify-end">
            <nuxt-link
              v-if="vars.facebookUrl"
              :external="true"
              :to="vars.facebookUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="var(--c-primary)"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-tertiary)]"
                  />
                  <path
                    d="M19.3307 19.0002H20.9974L21.6641 16.3335H19.3307V15.0002C19.3307 14.3135 19.3307 13.6668 20.6641 13.6668H21.6641V11.4268C21.4467 11.3982 20.6261 11.3335 19.7594 11.3335C17.9494 11.3335 16.6641 12.4382 16.6641 14.4668V16.3335H14.6641V19.0002H16.6641V24.6668H19.3307V19.0002Z"
                    fill="#fff"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.tiktokUrl"
              :external="true"
              :to="vars.tiktokUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="var(--c-primary)"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-tertiary)]"
                  />
                  <path
                    d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                    fill="#fff"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.instagramUrl"
              :external="true"
              :to="vars.instagramUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="var(--c-primary)"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-tertiary)]"
                  />
                  <path
                    d="M15.2026 11.3335H20.8026C22.9359 11.3335 24.6693 13.0668 24.6693 15.2002V20.8002C24.6693 21.8257 24.2619 22.8092 23.5367 23.5343C22.8116 24.2594 21.8281 24.6668 20.8026 24.6668H15.2026C13.0693 24.6668 11.3359 22.9335 11.3359 20.8002V15.2002C11.3359 14.1747 11.7433 13.1912 12.4685 12.466C13.1936 11.7409 14.1771 11.3335 15.2026 11.3335ZM15.0693 12.6668C14.4328 12.6668 13.8223 12.9197 13.3722 13.3698C12.9221 13.8199 12.6693 14.4303 12.6693 15.0668V20.9335C12.6693 22.2602 13.7426 23.3335 15.0693 23.3335H20.9359C21.5725 23.3335 22.1829 23.0806 22.633 22.6306C23.0831 22.1805 23.3359 21.57 23.3359 20.9335V15.0668C23.3359 13.7402 22.2626 12.6668 20.9359 12.6668H15.0693ZM21.5026 13.6668C21.7236 13.6668 21.9356 13.7546 22.0919 13.9109C22.2481 14.0672 22.3359 14.2791 22.3359 14.5002C22.3359 14.7212 22.2481 14.9331 22.0919 15.0894C21.9356 15.2457 21.7236 15.3335 21.5026 15.3335C21.2816 15.3335 21.0696 15.2457 20.9133 15.0894C20.7571 14.9331 20.6693 14.7212 20.6693 14.5002C20.6693 14.2791 20.7571 14.0672 20.9133 13.9109C21.0696 13.7546 21.2816 13.6668 21.5026 13.6668ZM18.0026 14.6668C18.8867 14.6668 19.7345 15.018 20.3596 15.6431C20.9847 16.2683 21.3359 17.1161 21.3359 18.0002C21.3359 18.8842 20.9847 19.7321 20.3596 20.3572C19.7345 20.9823 18.8867 21.3335 18.0026 21.3335C17.1185 21.3335 16.2707 20.9823 15.6456 20.3572C15.0205 19.7321 14.6693 18.8842 14.6693 18.0002C14.6693 17.1161 15.0205 16.2683 15.6456 15.6431C16.2707 15.018 17.1185 14.6668 18.0026 14.6668ZM18.0026 16.0002C17.4722 16.0002 16.9635 16.2109 16.5884 16.5859C16.2133 16.961 16.0026 17.4697 16.0026 18.0002C16.0026 18.5306 16.2133 19.0393 16.5884 19.4144C16.9635 19.7894 17.4722 20.0002 18.0026 20.0002C18.533 20.0002 19.0417 19.7894 19.4168 19.4144C19.7919 19.0393 20.0026 18.5306 20.0026 18.0002C20.0026 17.4697 19.7919 16.961 19.4168 16.5859C19.0417 16.2109 18.533 16.0002 18.0026 16.0002Z"
                    fill="#fff"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.youtubeUrl"
              :external="true"
              :to="vars.youtubeUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="var(--c-primary)"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-tertiary)]"
                  />
                  <path
                    d="M18.0026 12.6665C18.5726 12.6665 19.1573 12.6812 19.7239 12.7052L20.3933 12.7372L21.0339 12.7752L21.6339 12.8158L22.1819 12.8585C22.7766 12.904 23.3362 13.1578 23.7623 13.5752C24.1883 13.9926 24.4536 14.5469 24.5113 15.1405L24.5379 15.4238L24.5879 16.0305C24.6346 16.6592 24.6693 17.3445 24.6693 17.9998C24.6693 18.6552 24.6346 19.3405 24.5879 19.9692L24.5379 20.5758C24.5293 20.6732 24.5206 20.7672 24.5113 20.8592C24.4535 21.4529 24.1882 22.0073 23.762 22.4247C23.3358 22.8421 22.7761 23.0958 22.1813 23.1412L21.6346 23.1832L21.0346 23.2245L20.3933 23.2625L19.7239 23.2945C19.1505 23.3194 18.5766 23.3323 18.0026 23.3332C17.4286 23.3323 16.8547 23.3194 16.2813 23.2945L15.6119 23.2625L14.9713 23.2245L14.3713 23.1832L13.8233 23.1412C13.2286 23.0957 12.669 22.8419 12.2429 22.4245C11.8169 22.0071 11.5517 21.4528 11.4939 20.8592L11.4673 20.5758L11.4173 19.9692C11.3663 19.3139 11.3392 18.6571 11.3359 17.9998C11.3359 17.3445 11.3706 16.6592 11.4173 16.0305L11.4673 15.4238C11.4759 15.3265 11.4846 15.2325 11.4939 15.1405C11.5516 14.547 11.8167 13.9928 12.2427 13.5754C12.6686 13.158 13.228 12.9042 13.8226 12.8585L14.3699 12.8158L14.9699 12.7752L15.6113 12.7372L16.2806 12.7052C16.8543 12.6803 17.4284 12.6674 18.0026 12.6665ZM18.0026 13.9998C17.4526 13.9998 16.8866 14.0145 16.3359 14.0372L15.6839 14.0685L15.0579 14.1052L14.4699 14.1452L13.9313 14.1872C13.6482 14.2073 13.3813 14.3269 13.178 14.525C12.9747 14.723 12.8481 14.9867 12.8206 15.2692C12.7426 16.0752 12.6693 17.0785 12.6693 17.9998C12.6693 18.9212 12.7426 19.9245 12.8206 20.7305C12.8773 21.3118 13.3386 21.7638 13.9313 21.8125L14.4699 21.8538L15.0579 21.8938L15.6839 21.9312L16.3359 21.9625C16.8866 21.9852 17.4526 21.9998 18.0026 21.9998C18.5526 21.9998 19.1186 21.9852 19.6693 21.9625L20.3213 21.9312L20.9473 21.8945L21.5353 21.8545L22.0739 21.8125C22.357 21.7924 22.6239 21.6727 22.8272 21.4747C23.0305 21.2766 23.1571 21.013 23.1846 20.7305C23.2626 19.9245 23.3359 18.9212 23.3359 17.9998C23.3359 17.0785 23.2626 16.0752 23.1846 15.2692C23.1571 14.9867 23.0305 14.723 22.8272 14.525C22.6239 14.3269 22.357 14.2073 22.0739 14.1872L21.5353 14.1458L20.9473 14.1058L20.3213 14.0685L19.6693 14.0372C19.114 14.0133 18.5584 14.0008 18.0026 13.9998ZM16.6693 16.3832C16.6692 16.318 16.6851 16.2538 16.7155 16.1962C16.7459 16.1386 16.79 16.0893 16.8438 16.0525C16.8976 16.0158 16.9596 15.9928 17.0243 15.9854C17.0891 15.9781 17.1546 15.9867 17.2153 16.0105L17.2693 16.0372L20.0693 17.6532C20.125 17.6853 20.1722 17.7305 20.2068 17.7848C20.2413 17.8391 20.2623 17.9009 20.2679 17.9651C20.2734 18.0292 20.2634 18.0937 20.2387 18.1532C20.214 18.2126 20.1753 18.2652 20.1259 18.3065L20.0693 18.3465L17.2693 19.9632C17.2128 19.9958 17.1493 20.0142 17.0841 20.0167C17.019 20.0192 16.9542 20.0058 16.8954 19.9775C16.8367 19.9492 16.7857 19.907 16.747 19.8546C16.7083 19.8021 16.683 19.741 16.6733 19.6765L16.6693 19.6165V16.3832Z"
                    fill="#fff"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link
              v-if="vars.linkedinUrl"
              :external="true"
              :to="vars.linkedinUrl"
              target="_blank"
              class="n-link tw-group"
            >
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="18"
                    cy="18"
                    r="18"
                    fill="var(--c-primary)"
                    class="tw-duration-300 group-hover:tw-fill-[var(--c-tertiary)]"
                  />
                  <path
                    d="M14.6276 13.3335C14.6274 13.6871 14.4868 14.0262 14.2366 14.2761C13.9864 14.526 13.6472 14.6664 13.2936 14.6662C12.94 14.666 12.6009 14.5254 12.351 14.2752C12.1011 14.025 11.9608 13.6858 11.9609 13.3322C11.9611 12.9786 12.1018 12.6395 12.3519 12.3896C12.6021 12.1396 12.9413 11.9993 13.2949 11.9995C13.6486 11.9997 13.9876 12.1403 14.2376 12.3905C14.4875 12.6407 14.6278 12.9799 14.6276 13.3335ZM14.6676 15.6535H12.0009V24.0002H14.6676V15.6535ZM18.8809 15.6535H16.2276V24.0002H18.8543V19.6202C18.8543 17.1802 22.0343 16.9535 22.0343 19.6202V24.0002H24.6676V18.7135C24.6676 14.6002 19.9609 14.7535 18.8543 16.7735L18.8809 15.6535Z"
                    fill="#fff"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
        </div>
      </div>

      <div class="row y-gap-30 justify-between tw-mt-5">
        <div v-if="columns1" class="col-lg-4 lg:tw-hidden">
          <small style="color: #999999 !important">{{ vars.columnTitle1Text }}</small>
          <div class="footer__list">
            <nuxt-link v-for="(item, index) in columns1" :to="item.link" :external="true" :key="index" class="n-link"
              ><small>{{ item.item }}</small></nuxt-link
            >
          </div>
        </div>

        <div class="col-lg-4 tw-hidden tw-flex-col lg:tw-flex">
          <p>{{ vars.companyTradingAsText }}</p>
          <p>{{ vars.companyText }}</p>
          <p class="tw-whitespace-nowrap">Company Number: {{ vars.companyNumberText }}</p>
          <p>Registered Address: {{ vars.companyAddressText }}</p>
          <p>
            Redress Scheme:
            {{ vars.redressSchemeText }}
          </p>
          <p>
            <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
              {{ vars.companyRedressSchemeLinkUrl }}
            </a>
          </p>
          <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
            <img style="max-height: 52px; min-width: 56px" :title="logo.title" :alt="logo.title" :src="logo.photo" />
          </a>
        </div>

        <div class="col-xl-6 col-lg-7 tw-mt-5">
          <div class="justify-between tw-flex tw-flex-col tw-gap-y-12 lg:tw-flex-row">
            <div v-if="columns1" class="col-lg-4 tw-hidden tw-flex-col lg:tw-flex">
              <small style="color: #999999 !important">{{ vars.columnTitle1Text }}</small>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns1"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><small>{{ item.item }}</small></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns2" class="col-md-auto col-6">
              <small style="color: #999999 !important">{{ vars.columnTitle2Text }}</small>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns2"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><small>{{ item.item }}</small></nuxt-link
                >
              </div>
            </div>

            <div v-if="columns3" class="col-md-auto col-6">
              <small style="color: #999999 !important">{{ vars.columnTitle3Text }}</small>
              <div class="footer__list">
                <nuxt-link
                  v-for="(item, index) in columns3"
                  :to="item.link"
                  :external="true"
                  :key="index"
                  class="n-link"
                  ><small>{{ item.item }}</small></nuxt-link
                >
              </div>
            </div>

            <div class="col-md-auto col-6">
              <div class="footer__list !tw-mt-0 lg:tw-hidden">
                <p>{{ vars.companyTradingAsText }}</p>
                <p>{{ vars.companyText }}</p>
                <p class="tw-whitespace-nowrap">Company Number: {{ vars.companyNumberText }}</p>
                <p>Registered Address: {{ vars.companyAddressText }}</p>
                <p>
                  Redress Scheme:
                  {{ vars.redressSchemeText }}
                </p>
                <p>
                  <a :href="vars.companyRedressSchemeLinkUrl" class="n-link" target="_blank" rel="noreferrer">
                    {{ vars.companyRedressSchemeLinkUrl }}
                  </a>
                </p>
                <a v-for="(logo, index) in redress" :key="`redressLogos-${index}`" class="n-link !tw-mt-3">
                  <img
                    style="max-height: 52px; min-width: 56px"
                    :title="logo.title"
                    :alt="logo.title"
                    :src="logo.photo"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer__bottom tw-mt-6">
        <div class="row justify-between md:justify-center">
          <div class="col-auto lg:tw-w-full">
            <div class="row X-gap-10 y-gap-10 tw-items-center lg:tw-flex-row-reverse lg:tw-justify-between">
              <div class="col-auto"><library-footer-iceberg-links /></div>
              <div class="col-auto" style="font-size: 14px !important">
                © {{ new Date().getFullYear() }} {{ company.name }}. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-flex tw-w-full tw-py-16" style="background-color: var(--c-primary)">
      <div
        class="container tw-flex tw-flex-col tw-items-start tw-justify-between tw-gap-4 md:tw-flex-row md:tw-items-center"
      >
        <div class="tw-flex-col tw-items-center tw-justify-start tw-gap-4">
          <p>Go to the next page.</p>
          <nuxt-link :to="vars.nextPageLinkUrl" class="n-link">
            <h2>{{ vars.nextPageTitleText }}</h2>
          </nuxt-link>
        </div>
        <div class="tw-flex tw-items-center tw-justify-center">
          <nuxt-link :to="vars.nextPageLinkUrl" class="n-link tw-flex tw-items-center tw-justify-center tw-gap-3"
            >Next page
            <span class="tw-pt-1"
              ><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.5303 4.99311C20.8232 5.286 20.8232 5.76087 20.5303 6.05377L15.7574 10.8267C15.4645 11.1196 14.9896 11.1196 14.6967 10.8267C14.4038 10.5338 14.4038 10.059 14.6967 9.76608L18.9393 5.52344L14.6967 1.2808C14.4038 0.987904 14.4038 0.51303 14.6967 0.220137C14.9896 -0.0727568 15.4645 -0.0727568 15.7574 0.220137L20.5303 4.99311ZM0 5.52344L0 4.77344L20 4.77344V5.52344V6.27344L0 6.27344L0 5.52344Z"
                  fill="white"
                /></svg></span
          ></nuxt-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineNuxtComponent, navigateTo } from '#app';
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';

interface MenuItem {
  name: string;
  url: string;
  has_sub_menu: boolean;
  is_open_new_tab: boolean;
  sub_menus?: MenuItem[];
}

export default defineNuxtComponent({
  name: 'CopeAndCoFooter',
  mixins: [ComponentMixin],

  data() {
    return {
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null as number | null,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
        v5: 'v5',
      },
      // theme state for variant2 logo
      isLightMode: false,
      themeObserver: null as MutationObserver | null,
    };
  },


  computed: {
    ...mapState(useWebsiteStore, ['company', 'headerMenuItems']),

    redress() {
      return this.groupedVariables.redress;
    },
    columns1() {
      return this.groupedVariables.columns1;
    },
    columns2() {
      return this.groupedVariables.columns2;
    },
    middles() {
      return this.groupedVariables.middles;
    },
    columns3() {
      return this.groupedVariables.columns3;
    },
    cards() {
      return this.groupedVariables.cards;
    },

    /** Variant1 & Variant3 için sabit logo */
    logo(): string {
      const currentCompany = this.company as any;
      return currentCompany?.logo || '';
    },

    /** Variant2 için: light/dark moda göre logo */
    logoV2(): string {
      const currentCompany = this.company as any;
      const defaultLogo = currentCompany?.logo || '';
      const lightLogo = currentCompany?.light_logo || '';
      return this.isLightMode ? lightLogo || defaultLogo : defaultLogo;
    },

    /** Eğer footer menüsünde headerMenuItems kullanıyorsanız */
    footerMenuItems(): MenuItem[] {
      return (this.headerMenuItems as MenuItem[]) || [];
    },
  },

  mounted() {
    // scroll durumunu izlemek için
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    // tema başlangıç durumunu al
    this.isLightMode = document.documentElement.classList.contains('light-mode');

    // HTML elementinin class değişikliklerini izleyerek 'light-mode' güncelle
    const observer = new MutationObserver(() => {
      this.isLightMode = document.documentElement.classList.contains('light-mode');
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    this.themeObserver = observer;
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.themeObserver?.disconnect();
  },

  methods: {
    handleScroll(): void {
      this.isScrolled = window.scrollY > 50;
    },

    toggleSubMenu(index: number): void {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    handleMenuLinkClick(menuItem: MenuItem): void {
      if (!menuItem || menuItem.has_sub_menu || !menuItem.url) return;
      navigateTo(menuItem.url, {
        external: menuItem.is_open_new_tab,
        open: { target: menuItem.is_open_new_tab ? '_blank' : '_self' },
      });
    },
  },
  
    
 
});
</script>

<style scoped>
.info p {
  font-family: var(--f-primary), sans-serif !important;
  font-weight: 300 !important;
  line-height: 160% !important;
  color: var(--c-text-tertiary) !important;
}
.info a:hover {
  color: var(--c-primary) !important;
}

a p {
  transition: all 0.3s;
}

a:hover p {
  color: var(--c-primary) !important;
}

.footer {
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
}

/* Submenu ilk etapta görünmesin */
.footer-submenu {
  display: none;
}

.no-margin-top .footer__list {
  margin-top: 0;
}

/* openSubMenu eşleştiğinde 'is-active' class'ı ile görünür */
.footer-submenu.is-active {
  display: block;
}

.footer-menu-item a {
  display: inline-flex;
  align-items: center;
}

.footer-submenu-item a {
  display: block;
}
</style>
